import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RegistrationService } from '../shared/registration.service';

@Component({
    selector: 'app-driver-my-documents',
    templateUrl: './driver-my-documents.component.html',
    styleUrls: ['./driver-my-documents.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule
    ]
})
export class DriverMyDocumentsComponent implements OnInit {
  constructor(
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute,
    private readonly registrationService: RegistrationService
  ) {}

  ngOnInit(): void {}

  backAction() {
    this.location.back();
  }
  navigateToPersonalDocuments() {
    this.registrationService.navigateToDocuments(this.activatedRoute);
  }

  navigateToTrainingDocuments() {
    this.registrationService.navigateToTrainingDocuments(this.activatedRoute);
  }

  navigateToVehicleImages() {
    this.registrationService.navigateToVehicleImages(this.activatedRoute);
  }

  navigateToPayrollDocuments() {
    this.registrationService.navigateToPayrollDocuments(this.activatedRoute);
  }
}
